import React, { useState } from 'react';

import { Box, TextField, Popover } from '@mui/material';

import { Users } from 'react-feather';

import { CapacityFilterPicker } from '../pickers/CapacityFilterPicker';

import type { CapacityValues } from '../../../types/components/filter_bar_types';
import { getCapacityText } from '../utils';
import { Selector } from './Selector';
export interface CapacityFilterSelectorProps {
  initialValues: CapacityValues;
  onSubmit: (values: CapacityValues) => void;
  onCancel: () => void;
}

export const CapacityFilterSelector = ({
  initialValues,
  onSubmit,
  onCancel,
}: CapacityFilterSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const valueText = getCapacityText(initialValues);
  const handleSubmit = (values: CapacityValues) => {
    onSubmit(values);
    handleClose();
  };
  const handleClear = () => {
    onCancel();
    handleClose();
  };
  return (
    <Selector>
      <Users style={{ marginBottom: '16px' }} />
      <TextField
        size="small"
        label="Guests"
        value={valueText}
        onClick={handleClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleClick(event);
          }
        }}
        fullWidth
        InputProps={{
          readOnly: true,
          sx: {
            '& .MuiInputBase-input:focus': {
              backgroundColor: 'transparent',
            },
          },
        }}
      />
      <Popover
        id="event-capacity-selector-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box padding="24px">
          <CapacityFilterPicker
            initialValues={initialValues}
            onSubmit={handleSubmit}
            onCancel={handleClear}
          />
        </Box>
      </Popover>
    </Selector>
  );
};
